/**
 * SCO-839 (plan #718 §5.5): the coach-facing lines for the typed refusals.
 * PENDING Jonathan's word (D8): one place to swap. `[Name]` is the producer.
 */
export var NUDGE_REFUSAL_COPY = {
    board_changed: 'The board just changed. Tap again.',
    nudges_paused: 'Nudges are paused right now.',
    producer_excused: '[Name] is out today.',
    /** No name on the card: the same line with "This producer" (pending too). */
    producer_excused_unnamed: 'This producer is out today.'
};
var assertNever = function (x) {
    throw new Error("unhandled nudge state ".concat(String(x)));
};
export var nudgeButtonView = function (state, producerName) {
    switch (state) {
        case 'idle':
            return { label: 'Nudge', disabled: false };
        case 'sending':
            return { label: 'Sending…', disabled: true };
        case 'sent':
            return { label: 'Sent', disabled: true };
        case 'rate_limited':
            return { label: 'Try again soon', disabled: true };
        case 'board_changed':
            // Retryable: a new tap writes the nudge from the board as it is now.
            return { label: NUDGE_REFUSAL_COPY.board_changed, disabled: false };
        case 'nudges_paused':
            return { label: NUDGE_REFUSAL_COPY.nudges_paused, disabled: true };
        case 'producer_excused': {
            var label = producerName ? NUDGE_REFUSAL_COPY.producer_excused.replace('[Name]', function () { return producerName; }) : NUDGE_REFUSAL_COPY.producer_excused_unnamed;
            return { label: label, disabled: true };
        }
        case 'retry_wait':
            // The existing generic words (no new copy): disabled until the wait ends.
            return { label: 'Try again', disabled: true };
        case 'error':
            return { label: 'Try again', disabled: false };
        default:
            return assertNever(state);
    }
};
